import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth-store.js';

const navItems = [
  { to: '/admin', label: '📊 Dashboard', end: true },
  { to: '/admin/domains', label: '🌐 Allowed Domains' },
  { to: '/admin/invites', label: '✉️ Invites' },
  { to: '/admin/access', label: '🔑 Admin Access' },
];

export default function AdminLayout() {
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-neutral-950">
      {/* Sidebar */}
      <aside className="w-56 shrink-0 border-r border-neutral-800 bg-neutral-900 flex flex-col">
        <div className="px-5 py-5 border-b border-neutral-800">
          <div className="flex items-center gap-2">
            <span>🔥</span>
            <span className="font-bold text-neutral-100 text-sm">Ember Admin</span>
          </div>
        </div>
        <nav className="flex-1 px-2 py-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? 'bg-ember-600/20 text-ember-400 font-medium'
                    : 'text-neutral-400 hover:bg-neutral-800 hover:text-neutral-200'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-4 py-4 border-t border-neutral-800 space-y-2">
          <button
            onClick={() => navigate('/')}
            className="w-full text-left text-xs text-neutral-500 hover:text-neutral-300 transition-colors px-1"
          >
            ← Back to app
          </button>
          <button
            onClick={() => { void logout(); navigate('/login'); }}
            className="w-full text-left text-xs text-neutral-500 hover:text-neutral-300 transition-colors px-1"
          >
            Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
}
